module.exports = __webpack_public_path__ + "img/m_video_bg_mask.d0642ad0.png";